<template>
  <div style="float:left">
    <v-btn depressed style="background:#607D8B;" dark dense @click.stop="dialog = true" class="my-2">
      <v-icon class="mr-2">mdi-calendar-text</v-icon>
      Modifier la date
    </v-btn>
    <v-dialog width="350px" peristent v-model="dialog">
      <v-card>
        <v-card-title class="headline" style="background:#607D8B; color:white; justify-content: center">
          Date d'expiration
        </v-card-title>
        <v-card-text>
          <v-date-picker
              v-model="editableDate"
              style="background:#607D8B"
              color="green--text"
              no-title
              scrollable
              actions
          >
            <v-btn text color="purple" @click.native="onSaveChanges">
              Enregistrer
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click.native="dialog = false">
              Annuler
            </v-btn>
          </v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import apiClient from "../../../config/api.js";
import moment from "moment";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  props: ["licence"],
  data() {
    return {
      isMobile: isMobileDevice(),
      dialog: false,
      editableDate: null
    };
  },
  mounted() {
    this.editableDate = new Date(this.licence[0].expirationDate)
        .toISOString()
        .substr(0, 10);
  },
  methods: {
    onSaveChanges() {
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/admin/licence`, {
            expirationDate: this.editableDate + "T23:59:59.000+0000"
          })
          .then(() => {
            this.dialog = false;
            this.$parent.$parent.$parent.$parent.$parent.licence[0].expirationDate =
                this.editableDate + "T23:59:59.000+0000";
            this.$parent.$parent.$parent.$parent.$parent.diff = moment(
                this.editableDate
            ).diff(moment(), "days");
          })
          .catch(() => {
            this.dialog = false;

          });
    }
  }
};
</script>
